import React, { useEffect, useState } from "react";
import { PhoneInput } from "react-international-phone";
import { useDispatch, useSelector } from "react-redux";
import { setAccept, setCheckAccept, setCustomer, setPhone1, setPhone2, setPhone3, setStep } from "../../../Reducer/customerSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { toast } from "react-toastify";
import moment from "moment";
import Handler from "../../../Helpers/Components/Handler";
import Select from 'react-select'
import Modal from "../../../Helpers/Components/Modal";
import DatePicker from "react-multi-date-picker";
import { getCookie } from "../../../Helpers/Utils";
import { useParams } from "react-router-dom";

const Verification = (props) => {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const { id } = useParams()
    const person = getCookie('person')
    const [open, setOpen] = useState(false);
    const phone1 = useSelector((state => state?.customer?.phone1))
    const phone2 = useSelector((state => state?.customer?.phone2))
    const phone3 = useSelector((state => state?.customer?.phone3))
    const accept = useSelector((state => state?.customer?.accept))
    const checkAccept = useSelector((state => state?.customer?.checkAccept))
    const customer = useSelector(state => state?.customer?.customer)
    const validEmail = new RegExp('([a-z0-9.]{2,})+@([a-z]{3,})+([.]{1})+[a-z]{2,3}');
    const [timerSchedule1, setTimerSchedule1] = useState()
    const validPhoneNumber = new RegExp('^[6-9]{1}[0-9]{9}');
    const [timerSchedule2, setTimerSchedule2] = useState()
    const [timerSchedule3, setTimerSchedule3] = useState()

    const handleNext = async () => {
        if (!phone1?.phone || ((phone1?.code === "+91" || phone1?.code === "91") && !validPhoneNumber?.test(phone1?.phone))) {
            toast.error("Primary number is invalid")
        } else if (phone2?.phone && ((phone2?.code === "+91" || phone2?.code === "91") && !validPhoneNumber?.test(phone2?.phone))) {
            toast.error("Alt Number is invalid")
        } else if (phone3?.phone && ((phone3?.code === "+91" || phone3?.code === "91") && !validPhoneNumber?.test(phone3?.phone))) {
            toast.error("Alt Number 1 is invalid")
        } else if ((phone2?.phone && phone1?.phone && phone1?.phone === phone2?.phone) || (phone2?.phone && phone3?.phone && phone2?.phone === phone3?.phone) || (phone3?.phone && phone1?.phone && phone3?.phone === phone1?.phone)) {
            toast.error("Same mobile number not allowed")
        } else {
            if (!validEmail?.test(customer?.email?.toLowerCase())) {
                toast.error("Email ID is empty")
            }
            let phone = []
            phone1?.phone && phone?.push({ phone: phone1?.phone, priority: phone1?.priority || 1, type: phone1?.type || "normal", code: phone1?.code || "+91", both: phone1?.both || false })
            phone3?.phone && phone?.push({ phone: phone3?.phone, priority: phone3?.priority || 3, type: phone3?.type || "normal", code: phone3?.code || "+91", both: phone3?.both || false })
            phone2?.phone && phone?.push({ phone: phone2?.phone, priority: phone2?.priority || 2, type: phone2?.type || "normal", code: phone2?.code || "+91", both: phone2?.both || false })
            let dataToBeSent = {
                email: customer?.email,
                phone,
                dob: customer?.dob ? moment(new Date(customer?.dob))?.format("DD-MM-YYYY") : moment(new Date(new Date()?.setFullYear(new Date()?.getFullYear() - 18)))?.format("DD-MM-YYYY")
            }
            setLoading(true)
            const response = await Handler({ method: 'patch', url: `/customer/details/second/update/${props?.customerId}`, data: dataToBeSent })
            if (response?.success) {
                dispatch(setStep(2))
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    const handlePhone1 = (name, value) => {
        dispatch(setPhone1({ [name]: value }))
    }
    const handlePhone2 = (name, value) => {
        dispatch(setPhone2({ [name]: value }))
    }
    const handlePhone3 = (name, value) => {
        dispatch(setPhone3({ [name]: value }))
    }
    const handleSendOtp = async (index) => {
        if ((phone2?.phone && phone1?.phone && phone1?.phone === phone2?.phone) || (phone2?.phone && phone3?.phone && phone2?.phone === phone3?.phone) || (phone3?.phone && phone1?.phone && phone3?.phone === phone1?.phone)) {
            toast.error("Same mobile number not allowed")
        } else {
            if (index === 0 && !validPhoneNumber?.test(phone1?.phone) && (phone1?.code === "+91" || phone1?.code === "91")) {
                toast.error("Invalid phone number")
                return
            }
            if (index === 1 && !validPhoneNumber?.test(phone2?.phone) && (phone2?.code === "+91" || phone2?.code === "91")) {
                toast.error("Invalid phone number")
                return
            }
            if (index === 2 && !validPhoneNumber?.test(phone3?.phone) && (phone3?.code === "+91" || phone3?.code === "91")) {
                toast.error("Invalid phone number")
                return
            }
            if (index === 0) {
                dispatch(setPhone1({ load: true }))
            } else if (index === 1) {
                dispatch(setPhone2({ load: true }))
            } else if (index === 2) {
                dispatch(setPhone3({ load: true }))
            }
            if (index === 0 && !accept) {
                // const response = await Handler({ method: "post", url: `/customer/check/number`, data: { phone: index === 0 ? phone1?.phone : index === 1 ? phone2?.phone : phone3?.phone } })
                // if (response?.success) {
                //     if (response?.data?.exist && !accept) {
                //         dispatch(setPhone1({ load: false }))
                //         setOpen(true)
                //         return
                //     } else {
                dispatch(setAccept(true))
                //     }
                // } else {
                //     toast.error(response?.message)
                //     dispatch(setPhone1({ load: false }))
                //     return
                // }
            }
            const response = await Handler({
                method: 'post', url: `/customer/details/otp/${props?.customerId}`,
                data: {
                    phone: {
                        phone: index === 0 ? phone1?.phone : index === 1 ? phone2?.phone : phone3?.phone,
                        priority: index === 0 ? phone1?.priority : index === 1 ? phone2?.priority : phone3?.priority,
                        type: index === 0 ? (phone1?.type || "normal") : index === 1 ? (phone2?.type || "normal") : (phone3?.type || "normal"),
                        code: index === 0 ? (phone1?.code || "+91") : index === 1 ? (phone2?.code || "+91") : (phone3?.code || "+91"),
                        both: index === 0 ? (phone1?.both || false) : index === 1 ? (phone2?.both || false) : (phone3?.both || false)
                    }
                }
            })
            if (response?.success) {
                if (index === 0) {
                    clearInterval(timerSchedule1)
                    dispatch(setPhone1({ timer: 60, otpSent: true, disable: true }))
                } else if (index === 1) {
                    clearInterval(timerSchedule2)
                    dispatch(setPhone2({ timer: 60, otpSent: true, disable: true }))
                } else if (index === 2) {
                    clearInterval(timerSchedule3)
                    dispatch(setPhone3({ timer: 60, otpSent: true, disable: true }))
                }
                toast.success(response?.message)
                setTimeout(() => {
                    if (index === 0) {
                        dispatch(setPhone1({ disable: false }))
                    } else if (index === 1) {
                        dispatch(setPhone2({ disable: false }))
                    } else if (index === 2) {
                        dispatch(setPhone3({ disable: false }))
                    }
                }, 20000);
            } else {
                toast.error(response?.message)
            }
            if (index === 0) {
                dispatch(setPhone1({ load: false }))
            } else if (index === 1) {
                dispatch(setPhone2({ load: false }))
            } else if (index === 2) {
                dispatch(setPhone3({ load: false }))
            }
        }
    }
    const handleVerifyOtp = async (index) => {
        if ((phone2?.phone && phone1?.phone && phone1?.phone === phone2?.phone) || (phone2?.phone && phone3?.phone && phone2?.phone === phone3?.phone) || (phone3?.phone && phone1?.phone && phone3?.phone === phone1?.phone)) {
            toast.error("Same mobile number not allowed")
        } else if ((index === 0 ? phone1 : index === 1 ? phone2 : phone3)?.otp?.length !== 6) {
            toast.error("Invalid OTP")
        } else {
            if (index === 0 && !validPhoneNumber?.test(phone1?.phone) && (phone1?.code === "+91" || phone1?.code === "91")) {
                toast.error("Invalid phone number")
                return
            }
            if (index === 1 && !validPhoneNumber?.test(phone2?.phone) && (phone2?.code === "+91" || phone2?.code === "91")) {
                toast.error("Invalid phone number")
                return
            }
            if (index === 2 && !validPhoneNumber?.test(phone3?.phone) && (phone3?.code === "+91" || phone3?.code === "91")) {
                toast.error("Invalid phone number")
                return
            }
            if (index === 0) {
                dispatch(setPhone1({ load: true }))
            } else if (index === 1) {
                dispatch(setPhone2({ load: true }))
            } else if (index === 2) {
                dispatch(setPhone3({ load: true }))
            }
            const response = await Handler({
                method: 'patch', url: `/customer/details/verify/${props?.customerId}`,
                data: {
                    phone: {
                        phone: index === 0 ? phone1?.phone : index === 1 ? phone2?.phone : phone3?.phone,
                        priority: index === 0 ? phone1?.priority : index === 1 ? phone2?.priority : phone3?.priority,
                        type: index === 0 ? (phone1?.type || "normal") : index === 1 ? (phone2?.type || "normal") : (phone3?.type || "normal"),
                        code: index === 0 ? (phone1?.code || "+91") : index === 1 ? (phone2?.code || "+91") : (phone3?.code || "+91"),
                        both: index === 0 ? (phone1?.both || false) : index === 1 ? (phone2?.both || false) : (phone3?.both || false)
                    },
                    otp: index === 0 ? phone1?.otp : index === 1 ? phone2?.otp : phone3?.otp
                }
            })
            if (response?.success) {
                if (index === 0) {
                    clearInterval(timerSchedule1)
                    dispatch(setPhone1({ status: true, timer: 0 }))
                } else if (index === 1) {
                    clearInterval(timerSchedule2)
                    dispatch(setPhone2({ status: true, timer: 0 }))
                } else if (index === 2) {
                    clearInterval(timerSchedule3)
                    dispatch(setPhone3({ status: true, timer: 0 }))
                }
                toast.success(response?.message)
            } else {
                toast.error(response?.message)
            }
            if (index === 0) {
                dispatch(setPhone1({ load: false }))
            } else if (index === 1) {
                dispatch(setPhone2({ load: false }))
            } else if (index === 2) {
                dispatch(setPhone3({ load: false }))
            }
        }
    }
    const handlePhoneChange = (phone, code, i) => {
        if (i === 1) {
            handlePhone1('phone', phone || "")
            handlePhone1('code', code || "+91")
        } else if (i === 2) {
            handlePhone2('phone', phone || "")
            handlePhone2('code', code || "+91")
        } else if (i === 3) {
            handlePhone3('phone', phone || "")
            handlePhone3('code', code || "+91")
        }
    }
    const setSteps = () => {
        dispatch(setStep(0))
    }
    const handleChange = (e) => {
        dispatch(setCustomer({ [e.target.name]: e.target.value }))
    }
    const sendEmailOtp = async () => {
        if (!validEmail?.test(customer?.email?.toLowerCase())) {
            toast.error("Invalid email id")
        } else {
            dispatch(setCustomer({ emailLoad: true }))
            const response = await Handler({ method: 'post', url: `/customer/details/email/otp/${props?.customerId}`, data: { email: customer?.email } })
            if (response?.success) {
                dispatch(setCustomer({ disable: true, sentOtp: true }))
                toast.success(response?.message)
                setTimeout(() => {
                    dispatch(setCustomer({ disable: false }))
                }, 20000);
            } else {
                toast.error(response?.message)
            }
            dispatch(setCustomer({ emailLoad: false }))
        }
    }
    const verifyEmailOtp = async () => {
        if (!validEmail?.test(customer?.email?.toLowerCase())) {
            toast.error("Invalid email id")
        } else if (customer?.otp?.length !== 5) {
            toast.error("Invalid OTP")
        } else {
            dispatch(setCustomer({ emailLoad: true }))
            const response = await Handler({ method: 'patch', url: `/customer/details/email/verify/${props?.customerId}`, data: { email: customer?.email, otp: customer?.otp } })
            if (response?.success) {
                dispatch(setCustomer({ emailStatus: true }))
                toast.success(response?.message)
            } else {
                toast.error(response?.message)
            }
            dispatch(setCustomer({ emailLoad: false }))
        }
    }
    useEffect(() => {
        if (accept && checkAccept) {
            dispatch(setCheckAccept(false))
            handleSendOtp(0)
        }
    }, [accept, checkAccept])
    // useEffect(() => {
    //     let intervalId;
    //     if (phone1?.otpSent) {
    //         intervalId = setInterval(() => {
    //             let time = phone1?.timer - 1;
    //             if (time >= 0) {
    //                 dispatch(setPhone1({ timer: time }));
    //             } else {
    //                 clearInterval(intervalId);
    //                 // dispatch(setPhone1({ otpSent: false }));
    //             }
    //         }, 1000);
    //         setTimerSchedule1(intervalId);
    //     }
    //     return () => {
    //         clearInterval(intervalId);
    //     };
    // }, [phone1?.otpSent, phone1?.timer, dispatch]);
    // useEffect(() => {
    //     let intervalId;
    //     if (phone2?.otpSent) {
    //         intervalId = setInterval(() => {
    //             let time = phone2?.timer - 1;
    //             if (time >= 0) {
    //                 dispatch(setPhone2({ timer: time }));
    //             } else {
    //                 clearInterval(intervalId);
    //                 // dispatch(setPhone2({ otpSent: false }));
    //             }
    //         }, 1000);
    //         setTimerSchedule2(intervalId);
    //     }
    //     return () => {
    //         clearInterval(intervalId);
    //     };
    // }, [phone2?.otpSent, phone2?.timer, dispatch]);
    // useEffect(() => {
    //     let intervalId;
    //     if (phone3?.otpSent) {
    //         intervalId = setInterval(() => {
    //             let time = phone3?.timer - 1;
    //             if (time >= 0) {
    //                 dispatch(setPhone3({ timer: time }));
    //             } else {
    //                 clearInterval(intervalId);
    //                 // dispatch(setPhone3({ otpSent: false }));
    //             }
    //         }, 1000);
    //         setTimerSchedule3(intervalId);
    //     }
    //     return () => {
    //         clearInterval(intervalId);
    //     };
    // }, [phone3?.otpSent, phone3?.timer, dispatch]);
    return (
        <React.Fragment>
            <div className="card p-3 mb-3">
                <h6 className="mb-3">Primary Number</h6>
                <div className="row mb-3">
                    <div className="col-md-6 col-xl-3">
                        <Select
                            value={phone1?.type ? { label: phone1?.type?.toUpperCase(), value: phone1?.type } : { label: "NORMAL", value: "normal" }}
                            onChange={(e) => { handlePhone1('type', e.value) }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading || phone1?.status || phone1?.load}
                            options={[
                                { label: "NORMAL", value: "normal" },
                                { label: "WHATSAPP", value: "whatsapp" }
                            ]} />
                    </div>
                    <div className="col-md-6 col-xl-5 d-flex align-items-center justify-content-center gap-3">
                        <div className="input-group w-100">
                            <PhoneInput
                                defaultCountry="in"
                                disabled={loading || phone1?.status || phone1?.load || (person !== "admin" && id)}
                                value={phone1?.phone ? phone1?.code + phone1?.phone : ""}
                                onChange={(phone1, metadata) => {
                                    const code = `+${metadata.country.dialCode}`;
                                    const phone = phone1.replace(code, "").replace(/\s/g, "").replace(/-/g, "");
                                    handlePhoneChange(phone, code, 1)
                                }}
                                onPaste={(e) => {
                                    e.preventDefault();
                                    let pasteData = e.clipboardData.getData('Text');
                                    pasteData = pasteData.replace(/\D/g, '').slice(0, 10);
                                    handlePhone1('phone', pasteData)
                                    handlePhone1('code', e[0])
                                }}
                                inputClassName="flex-1"
                                className="flex-1"
                            />
                            {/* <input placeholder="Number" autoComplete="off" disabled id="phone" type="text" name="phone"  maxLength={10}  className="" /> */}
                            <button onClick={() => handleSendOtp(0)} className="input-group-text password-icon btn-theme btn send-otp" id="basic-addon2" disabled={loading || phone1?.disable || phone1?.status || phone1?.load}>{phone1.status ? <i className="fa-solid fa-circle-check text-green"></i> : (phone1?.otpSent ? "Resend OTP" : "Send OTP")}</button>
                        </div>
                        {
                            phone1?.status && person === "admin" ? <i className="fa-solid fa-pen-to-square cursor-pointer" onClick={() => dispatch(setPhone1({ status: false, otp: "", otpSent: false, load: false }))}></i> : ""
                        }
                    </div>
                    <div className="col-md-6 col-xl-4 d-flex align-items-center gap-2">
                        {phone1?.status ? "" :
                            <div className="input-group">
                                <input placeholder="OTP" autoComplete="off" disabled={loading || !phone1?.otpSent || phone1?.status || phone1?.load} id="otp" type="text" name="otp" value={phone1?.otp || ""} maxLength={6} onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handlePhone1("otp", e.target.value) } }} className="form-control password-input input-theme text-uppercase" />
                                <button onClick={() => handleVerifyOtp(0)} className="input-group-text password-icon btn-theme btn" id="basic-addon2" disabled={loading || !phone1?.otpSent || phone1?.status || phone1?.load}>Verify OTP</button>
                            </div>}

                        {/* {
                            phone1?.otpSent ? <span className="timer">{phone1?.timer}</span> : ""
                        } */}
                    </div>
                </div>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" value="" id="both1" disabled={loading || phone1?.status || phone1?.load} onChange={(e) => { dispatch(setPhone1({ both: e.target.checked })) }} checked={phone1?.both} />
                    <label className="form-check-label" htmlFor="both1"> Both </label>
                </div>
            </div>
            <div className="card p-3 mb-3">
                <h6 className="mb-3">Alt Number</h6>
                <div className="row mb-3">
                    <div className="col-md-6 col-xl-3">
                        <Select
                            value={phone2?.type ? { label: phone2?.type?.toUpperCase(), value: phone2?.type } : { label: "NORMAL", value: "normal" }}
                            onChange={(e) => { handlePhone2("type", e.value) }}
                            isDisabled={loading || phone2?.status || phone2?.load}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            options={[
                                { label: "NORMAL", value: "normal" },
                                { label: "WHATSAPP", value: "whatsapp" }
                            ]} />
                    </div>
                    <div className="col-md-6 col-xl-5 d-flex align-items-center justify-content-center gap-3">
                        <div className="input-group w-100">
                            <PhoneInput
                                defaultCountry="in"
                                disabled={loading || phone2?.status || phone2?.load}
                                value={phone2?.phone ? phone2?.code + phone2?.phone : ""}
                                onChange={(phone1, metadata) => {
                                    const code = `+${metadata.country.dialCode}`;
                                    const phone = phone1.replace(code, "").replace(/\s/g, "").replace(/-/g, "");
                                    handlePhoneChange(phone, code, 2)
                                }}
                                onPaste={(e) => {
                                    e.preventDefault();
                                    let pasteData = e.clipboardData.getData('Text');
                                    pasteData = pasteData.replace(/\D/g, '').slice(0, 10);
                                    handlePhone2('phone', pasteData)
                                    handlePhone2('code', e[0])
                                }}
                                inputClassName="flex-1"
                                className="flex-1"
                            />
                            <button onClick={() => handleSendOtp(1)} className="input-group-text password-icon btn-theme btn send-otp" id="basic-addon2" disabled={loading || phone2?.load || phone2?.disable || phone2?.status}>{phone2.status ? <i className="fa-solid fa-circle-check text-green"></i> : (phone2?.otpSent ? "Resend OTP" : "Send OTP")}</button>
                        </div>
                        {
                            phone2?.status && person === "admin" ? <i className="fa-solid fa-pen-to-square cursor-pointer" onClick={() => dispatch(setPhone2({ status: false, otp: "", otpSent: false, load: false }))}></i> : ""
                        }
                    </div>
                    <div className="col-md-6 col-xl-4 d-flex align-items-center gap-2">
                        {phone2?.status ? "" :
                            <div className="input-group">
                                <input placeholder="OTP" autoComplete="off" disabled={loading || !phone2?.otpSent || phone2?.load || phone2?.status} id="otp" type="text" name="otp" value={phone2?.otp || ""} maxLength={6} onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handlePhone2('otp', e.target.value) } }} className="form-control password-input input-theme text-uppercase" />
                                <button onClick={() => { handleVerifyOtp(1) }} className="input-group-text password-icon btn-theme btn" id="basic-addon2" disabled={loading || !phone2?.otpSent || phone2?.load || phone2?.status}>Verify OTP</button>
                            </div>}
                        {/* {
                            phone2?.otpSent ? <span className="timer">{phone2?.timer}</span> : ""
                        } */}
                    </div>
                </div>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" value="" id="both2" disabled={loading || phone2?.status || phone2?.load} onChange={(e) => { dispatch(setPhone2({ both: e.target.checked })) }} checked={phone2?.both} />
                    <label className="form-check-label" htmlFor="both2"> Both </label>
                </div>
            </div>
            <div className="card p-3 mb-3">
                <h6 className="mb-3">Alt Number 1</h6>
                <div className="row mb-3">
                    <div className="col-md-6 col-xl-3">
                        <Select
                            isDisabled={loading || phone3?.status || phone3?.load}
                            value={phone3?.type ? { label: phone3?.type?.toUpperCase(), value: phone3?.type } : { label: "NORMAL", value: "normal" }}
                            onChange={(e) => { handlePhone3('type', e.value) }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            options={[
                                { label: "NORMAL", value: "normal" },
                                { label: "WHATSAPP", value: "whatsapp" }
                            ]} />
                    </div>
                    <div className="col-md-6 col-xl-5 d-flex align-items-center justify-content-center gap-3">
                        <div className="input-group w-100">
                            <PhoneInput
                                defaultCountry="in"
                                disabled={loading || phone3?.status || phone3?.load}
                                value={phone3?.phone ? phone3?.code + phone3?.phone : ""}
                                onChange={(phone1, metadata) => {
                                    const code = `+${metadata.country.dialCode}`;
                                    const phone = phone1.replace(code, "").replace(/\s/g, "").replace(/-/g, "");
                                    handlePhoneChange(phone, code, 3)
                                }}
                                onPaste={(e) => {
                                    e.preventDefault();
                                    let pasteData = e.clipboardData.getData('Text');
                                    pasteData = pasteData.replace(/\D/g, '').slice(0, 10);
                                    handlePhone3('phone', pasteData)
                                    handlePhone3('code', e[0])
                                }}
                                inputClassName="flex-1"
                                className="flex-1"
                            />
                            <button onClick={() => handleSendOtp(2)} className="input-group-text password-icon btn-theme btn send-otp" id="basic-addon2" disabled={loading || phone3?.load || phone3?.disable || phone3?.status}>{phone3.status ? <i className="fa-solid fa-circle-check text-green"></i> : (phone3?.otpSent ? "Resend OTP" : "Send OTP")}</button>
                        </div>
                        {
                            phone3?.status && person === "admin" ? <i className="fa-solid fa-pen-to-square cursor-pointer" onClick={() => dispatch(setPhone3({ status: false, otp: "", otpSent: false, load: false }))}></i> : ""
                        }
                    </div>
                    <div className="col-md-6 col-xl-4 d-flex align-items-center gap-2">
                        {phone3?.status ? "" :
                            <div className="input-group">
                                <input placeholder="OTP" autoComplete="off" disabled={loading || phone3?.load || !phone3?.otpSent || phone3?.status} id="otp" type="text" name="otp" value={phone3?.otp || ""} maxLength={6} onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handlePhone3('otp', e.target.value) } }} className="form-control password-input input-theme text-uppercase" />
                                <button onClick={() => { handleVerifyOtp(2) }} className="input-group-text password-icon btn-theme btn" id="basic-addon2" disabled={loading || phone3?.load || !phone3?.otpSent || phone3?.status}>Verify OTP</button>
                            </div>}

                        {/* {
                            phone3?.otpSent ? <span className="timer">{phone3?.timer}</span> : ""
                        } */}
                    </div>
                </div> <div className="form-check">
                    <input className="form-check-input" type="checkbox" value="" id="both3" disabled={loading || phone3?.status || phone3?.load} onChange={(e) => { dispatch(setPhone3({ both: e.target.checked })) }} checked={phone3?.both} />
                    <label className="form-check-label" htmlFor="both3"> Both </label>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-5">
                    <label htmlFor="email" className="form-label"> Email ID </label>
                    <div className="input-group mb-3 d-flex align-items-center">
                        <input placeholder="Email ID" autoComplete="off" disabled={loading || customer?.emailStatus || customer?.disable} id="email" type="text" name="email" value={customer?.email || ""} onChange={handleChange} className="form-control password-input input-theme text-uppercase" />
                        <button onClick={sendEmailOtp} className="input-group-text password-icon btn-theme btn" id="basic-addon2" disabled={loading || customer?.emailStatus || customer?.disable || customer?.emailLoad}>{customer?.emailStatus ? <i className="fa-solid fa-circle-check text-success"></i> : (customer?.sentOtp ? "Resend OTP" : "Send OTP")}</button>
                        {customer?.emailLog?.error ? <i className="fa-solid fa-circle-info text-orange ms-2"></i> : ""}
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 d-flex align-items-center gap-2">

                    {
                        customer?.emailStatus ? (person === "admin" ? <i className="fa-solid fa-pen-to-square cursor-pointer" onClick={() => dispatch(setCustomer({ emailStatus: false }))}></i> : "") :
                            <div>
                                <label htmlFor="otp" className="form-label"> OTP </label>
                                <div className="input-group mb-3">
                                    <input placeholder="OTP" autoComplete="off" disabled={loading || !customer?.sentOtp || customer?.emailStatus} id="otp" type="text" name="otp" value={customer?.otp || ""} maxLength={5} onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleChange(e) } }} className="form-control password-input input-theme text-uppercase" />
                                    <button onClick={verifyEmailOtp} className="input-group-text password-icon btn-theme btn" id="basic-addon2" disabled={loading || !customer?.sentOtp || customer?.emailStatus || customer?.emailLoad}>Verify OTP</button>
                                </div>
                            </div>
                    }
                </div>
                <div className="col-md-6 col-xl-4">
                    <label htmlFor="dob" className="form-label"> DOB </label>
                    <div className=" datepicker-top">  <DatePicker
                        className="input-theme"
                        value={customer?.dob ? new Date(customer?.dob) : new Date(new Date()?.setFullYear(new Date()?.getFullYear() - 18))}
                        onChange={(e) => { dispatch(setCustomer({ dob: new Date(e)?.toString() })) }}
                        format="DD-MM-YYYY"
                        disabled={loading}
                        maxDate={new Date()?.setFullYear(new Date()?.getFullYear() - 18)}
                    />
                    </div>
                </div>
            </div>
            <NextPrev step={1} setStep={setSteps} last={7} onClick={handleNext} loading={loading} />
            <Modal header="Customer Already Exists in Customer Table" onShow={open} toggle={() => setOpen(false)} overlayToggle={() => { setOpen(false) }}>
                <div>Really Wanna add this customer ? </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-success" onClick={() => { dispatch(setAccept(true)); setOpen(false); setCheckAccept(true) }}>Accept</button><button className="btn btn-sm btn-danger" onClick={() => { dispatch(setAccept(false)); setOpen(false); }}>Reject</button>
                </div>
            </Modal>
        </React.Fragment >
    )
}

export default Verification;